import ProductsListFromCurrentLessor from './ProductsListFromCurrentLessor'

export default ProductsListFromCurrentLessor
